import { useQuery } from "@tanstack/react-query";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { getFooterPresignedUrl } from "./api";

export interface ProfileDetails {
  email: string;
  name: string;
  phone_number?: string;
  organization?: string;
  status: "ACTIVE" | "DELETED" | "PURGING" | "PURGED";
}

export const profileKeys = {
  root: ["profile"] as const,
  details: () => [...profileKeys.root, "details"] as const,
};

export function useProfileDetails() {
  const { authStatus } = useAuthenticator((c) => [c.authStatus]);

    return useQuery<ProfileDetails>({
    queryKey: profileKeys.details(),
    queryFn: async () => {
      const res = await getFooterPresignedUrl();
      const pd = res?.data?.profileDetails;
      return {
        email: pd?.email ?? "",
        name: pd?.name ?? "",
        phone_number: pd?.phone_number ?? "",
        organization: pd?.organization ?? "",
        status: pd?.status ?? "ACTIVE",
      };
    },
        enabled: authStatus === "authenticated",
        staleTime: 5 * 60 * 1000,
        refetchOnMount: true,
    });
}
